<template>
    <div class="pro-pic inner-upload-single">
        <transition-group tag="div" class="drag-wrap" v-show="imgListShow">
            <div class="drag-item" v-for="(file,index) in imgFileNew" :key="file.url"
                 draggable="true"
                 @dragstart="handleDragStart($event, file)"
                 @dragover.prevent="handleDragOver($event, file)"
                 @dragenter="handleDragEnter($event, file)"
                 @dragend="handleDragEnd($event, file)">
                <div

                    class="img-box"
                    :class="{ borderColorChange:file.url }"  :style="'width:'+width+'px;height:'+height+'px'">
                    <div v-if="file.url">
                        <el-image
                            class="avatar" ref="proPic"
                            :src="file.url"
                            :preview-src-list="srcList" :style="'width:'+width+'px;height:'+height+'px'">
                        </el-image>
                    </div>
                    <div v-if="file.url && !dragging" class="img-cover-wrap">
                        <i @click.stop="del(index)" class="el-icon-error"></i>
                    </div>
                </div>
            </div>
        </transition-group>
        <el-upload
            class="avatar-uploader"
            action="/service-center/upload/file/single"
            v-show="imgsBtn"
            :headers="headers"
            :show-file-list="false"
            :before-upload="beforeAvatarUpload"
            :disabled="disabledBtn"
            :on-success="handleAvatarSuccess"
            >
            <el-button>{{buttonName}}</el-button>
        </el-upload>
    </div>
</template>

<script>
    export default {
        name: "uploadMultiImage",
        props: {
            imgType:{
               type: String,
               default: ''
            },
            imgFile: {
                type: Array,
                default: () => []
            },
            buttonName: {
                type: String,
                default: '点击上传'
            },
            width: {
                type: String,
                default: '275'
            },
            height: {
                type: String,
                default: '200'
            },
            messSize: {
                type: String,
            },
            imgListShow: {
                type: Boolean,
                default: true
            },
            /**
             * 文件大小限制，单位：G, M, K ,B ，默认2M
             */
            maxSize: {
                type: String,
                default: '2M',
                validator(val){
                    return new RegExp(/^[\d]*[.]?[\d]*[gmkb]?$/i).test(val.trim())
                }
            },
            imgsBtn: {
                type: Boolean,
                default: true
            },
        },
        data() {
            return {
                dragging: null,
                disabledBtn: false,
                imgFileNew: [],
                headers: {
                    'Authorization': 'Bearer ' +  this.$cookies.get("api_access_token")
                },
                srcList: []
            }
        },
        watch:{
            imgFileNew (newVal) {
                if(newVal){
                    this.srcList = []
                    newVal.map((item)=>{
                        this.srcList.push(item.url)
                    })
                } else {
                    this.srcList = []
                }
            },
            imgFile: {
                handler(val) {
                    if(val){
                        this.imgFileNew = val
                        this.srcList = []
                        val.map((item)=>{
                            this.srcList.push(item.url)
                        })
                    } else {
                        this.imgFileNew = []
                        this.srcList = []
                    }
                },
                immediate: true,
                deep: true
            },
        },
        computed: {
            accept() {
                return 'image/jpeg,image/jpg'
            },
            maxSizeValue(){
                let n = this.maxSize.trim().replace(/[gmkb]/i, "")
                let u = (this.maxSize.trim().replace( n, "") || "b").toLowerCase()
                return Number(n) * {"g": 1073741824, "m": 1048576, "k": 1024, "b": 1}[u]
            }
        },
        created(){ console.log(this.$props,222)},
        methods: {
            handleProcess(res, file, v3, b){
                console.log(res, file, v3, b)
            },
            handleAvatarSuccess(res, file) {
                this.disabledBtn = false;
                this.imgFileNew.push(res)
                this.srcList.push(res.url)
                this.$emit('avatarChange', this.imgFileNew)
            },
            beforeAvatarUpload(file) {
                this.disabledBtn = true;
                const isJPG = file.type.indexOf('image') !== -1;
                // const isLt2M = file.size / 1024 / 1024 < 2;
                const isLt2M = file.size <= this.maxSizeValue;
                console.log(`filesize=${file.size}, maxsize=${this.maxSizeValue}`)
                if (!isJPG) {
                    this.$message.warning('上传图片只能是图片格式!');
                }
                if (!isLt2M) {
                    this.$message.warning(`上传图片大小不能超过 ${this.maxSize.toUpperCase()}!`);
                }
                let _this = this;
                let imgWidth = 0;
                let imgHeight = 0;
                let isSize = new Promise(function(resolve, reject) {
                    console.log(resolve)
                    let _URL = window.URL || window.webkitURL;
                    let img = new Image();
                    console.log(img)
                    img.onload = function() {
                        imgWidth = img.width;
                        imgHeight = img.height;
                        let valid =''
                        if(_this.$props.imgType != ''){
                            valid = (img.width === 734 && img.height === 412);
                        }else if(_this.$props.messSize && _this.$props.messSize.indexOf("230") !== -1){
                         valid = ((img.width === 230 && img.height === 143) || (img.width === 230 && img.height === 373));
                        }else if(_this.$props.messSize && _this.$props.messSize.indexOf("1920") !== -1){
                            valid = (img.width === 1920 && img.height === 300);
                        }else if(_this.$props.messSize && _this.$props.messSize.indexOf("375") !== -1){
                            valid = (img.width === 375 && img.height === 310);
                        }
                        console.log(valid)
                        valid ? resolve() : reject();
                    };
                    img.src = _URL.createObjectURL(file);
                    }).then(() => {
                        return file;
                    },
                    () => {
                        if(_this.$props.messSize){
                            _this.$message.warning({
                                message: '上传文件的图片大小不合符标准,'+_this.$props.messSize+'。当前上传图片的宽高分别为：' + imgWidth + 'px和' + imgHeight + 'px',
                                btn: false
                            });
                        }else{
                            _this.$message.warning({
                                message: '上传文件的图片大小不合符标准,当前上传图片的宽高分别为：' + imgWidth + 'px和' + imgHeight + 'px',
                                btn: false
                            });
                        }
                        this.disabledBtn = false;
                        return Promise.reject();
                    });


                return isJPG && isLt2M && isSize;;
            },
            del(index) {
                this.imgFileNew[index].url = ''
                this.imgFileNew.splice(index,1)
                this.srcList.splice(index,1)
                this.$emit('deleteImg', this.imgFileNew)
            },
            handleDragStart(e, item) {
                this.dragging = item
            },
            handleDragEnd(e, item) {
                this.dragging = null
            },
            handleDragOver(e) {
                e.dataTransfer.dropEffect = 'move'
            },
            handleDragEnter(e, item) {
                e.dataTransfer.effectAllowed = "move" //为需要移动的元素设置dragstart事件
                if (item === this.dragging) {
                    return
                }
                const newItems = [...this.imgFileNew]
                const src = newItems.indexOf(this.dragging)
                const dst = newItems.indexOf(item)
                newItems.splice(dst, 0, ...newItems.splice(src, 1))
                this.imgFileNew = newItems
                this.$emit('getDragImgFile', newItems)
            }
        }
    }
</script>

<style lang="less" scoped>
    button{
        width: 100px;
        background: #3d7fff;
        border: none;
        border-radius: 5px;
        font-size: 14px;
        color: #FFFFFF;
    }
    .container{
        width: 80px;
        height: 300px;
        position: absolute;
        left: 0;
        display:flex;
        flex-direction: column;
        padding: 0;
    }
    .item {
        margin-top: 10px;
        transition: all linear .3s
    }
    .drag-wrap {
        display: flex;
        flex-wrap: wrap;
        .drag-item {
            margin-right: 13px;
            margin-bottom: 13px;
            cursor: pointer;
            &:hover{
                .img-cover-wrap{
                    display: block;
                }
            }
            &:last-child {
                margin-right: 0;
            }
        }
    }
    .avatar-uploader-icon {
        color: #409eff;
        width: 275px;
        height: 200px;
        text-align: center;
        vertical-align: middle;
        display: table-cell;
        text-align: center;
        font-size: 12px;
        border: 1px dashed #ddd;
    }

    img {
        width:100%;
        height: 100%;
        display: block;
    }
    /deep/.el-image__preview{
        width: 100%;
        height: 100%;
    }
    .img-empty {
        vertical-align: sub;
        margin-top: 10px;
        margin-bottom: 10px;
    }

    .img-box {
        width: 100%;
        height: 100%;
        background-color: #f9fcff;
        border: dashed 1px #409eff;
        float: left;
        margin-right: 13px;
        position: relative;
    }

    .img-box:last-child {
        margin-right: 0;
    }

    .borderColorChange {
        border: solid 1px #ececec;
        background-color: #f9f9f9;
    }

    .el-icon-plus:before {
        content: "";
    }

    // 删除
    .img-cover-wrap {
        right: 5px;
        top: 5px;
        position: absolute;
        line-height: initial;
        display: none;
        i {
            font-size: 22px;
            color: #000;
            display: inline;
            cursor: pointer;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/uploadImage/index.vue